import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { ChatClient } from "@/leancloudFacade";
import { deviceId } from "@/pages/base/deviceId";
import { SET_IM_SESSION, CLOSE_CHAT_BOX } from "./Types";
import { VoidUrl } from "@/common/types";
import { FHTChatId } from "@/common/FHTChatId";
import { receiveNewMessage, updateUnreadMessageCount } from "../messages/Actions";
import { Contact } from "@/models/Contact";
import { loadedContactFromServer } from "../contacts/Actions";
import { assert } from "@/common/assert";
import { UrlHelperExtensions } from "@/url_helpers";
import defaultAvatarUrl from "@/assets/spriteSrcs/icon/defaultavatar.png";
import { formatImageUrl } from "@/common/utils";
import { UserApiApi } from "@/apis/api/UserApiApi";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";
export function setImSession(myself, chatClient) {
  return {
    type: SET_IM_SESSION,
    chatClient: chatClient,
    myself: myself
  };
}
export function initializeIm(info) {
  var _this = this;

  assert(info, "info is falsy");
  return function (dispatch, getState) {
    return __awaiter(_this, void 0, void 0, function () {
      var userApi, myself_1, me, u, im, err_1;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 5,, 6]);

            userApi = new UserApiApi();
            if (!info.UserId) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , userApi.userApiUserDetail({
              userId: info.UserId
            })];

          case 1:
            me = _b.sent();
            u = me.User.User;
            myself_1 = {
              userId: u.UserId,
              avatarUrl: formatImageUrl(u.AvatarUrl.AbsoluteUrl, ImageSizeTypeEnum.Thumbnail44whFill),
              clientId: u.ClientId,
              companyId: u.CompanyId,
              isMobileUser: u.IsMobileUser,
              url: UrlHelperExtensions.$ProfileUrl(u.UserId)
            };
            return [3
            /*break*/
            , 4];

          case 2:
            _a = {
              userId: undefined,
              avatarUrl: defaultAvatarUrl
            };
            return [4
            /*yield*/
            , deviceId];

          case 3:
            myself_1 = (_a.clientId = _b.sent(), _a.companyId = undefined, _a.isMobileUser = false, _a.url = VoidUrl, _a);
            _b.label = 4;

          case 4:
            im = new ChatClient(myself_1, {
              getContactByFHTChatId: function getContactByFHTChatId(chatId) {
                return __awaiter(this, void 0, Promise, function () {
                  var contact;
                  return __generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        contact = getState().contact.contacts[chatId.encode()];
                        if (!!contact) return [3
                        /*break*/
                        , 2];
                        return [4
                        /*yield*/
                        , Contact.getContactByFHTChatId(chatId, myself_1)];

                      case 1:
                        contact = _a.sent();
                        dispatch(loadedContactFromServer(contact));
                        _a.label = 2;

                      case 2:
                        return [2
                        /*return*/
                        , contact];
                    }
                  });
                });
              }
            });
            im.onReceivedMessage(function (m, contact) {
              dispatch(receiveNewMessage(m, contact.chatId));
            });
            im.onUnreadMessageCountUpdated(function (m, contact, unreadMessageCount) {
              assert(typeof unreadMessageCount === "number", "unreadMessageCount is not number?");
              var ccid = getState().contact.currentContactChatId;
              var currentContactChatId = ccid ? FHTChatId.decode(ccid) : undefined;
              dispatch(updateUnreadMessageCount(m, contact.chatId, unreadMessageCount, contact.clientId === myself_1.clientId, currentContactChatId));
            });
            dispatch(setImSession(myself_1, im));
            return [3
            /*break*/
            , 6];

          case 5:
            err_1 = _b.sent();
            console.error(err_1);
            return [3
            /*break*/
            , 6];

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
}
export function closeChatBox() {
  return {
    type: CLOSE_CHAT_BOX
  };
}